import styled from "styled-components";

import NavBar from "@src/components/NavBar";
import { Home, About, Family, Footer, CollectrSection, DiscordRedirect } from "@pages/index";

const StyledApp = styled.div`
  background: ${({ theme }) => theme.colors.secondaryBgColor};
`;

function App() {
  if (typeof window !== "undefined") {
    const { pathname } = window.location;

    if (pathname === "/discord") {
      return <DiscordRedirect />;
    }

    if (pathname !== "/") {
      window.location.replace("/");
      return null;
    }
  }

  return (
    <StyledApp>
      <NavBar />
      <Home />
      <About />
      <CollectrSection />
      <Family />
      <Footer />
    </StyledApp>
  );
}

export default App;
